"use client";

import { disableDraftMode } from "@site/actions";
import { useFormStatus } from "react-dom";

import { Icon } from "@/components/ui/icons";

interface DraftModeToastProps {
  isDraftMode: boolean;
}

function DraftModeFormContent() {
  const { pending } = useFormStatus();

  return (
    <div className="fixed bottom-6 left-1/2 z-[80] -translate-x-1/2 transform">
      <div
        className={`flex items-center gap-3 rounded-lg border border-yellow-400/50 bg-yellow-600 px-4 py-3 shadow-lg backdrop-blur transition-all ${
          pending ? "animate-pulse opacity-80" : ""
        }`}
      >
        <div className="flex items-center gap-2 text-sm font-medium text-white">
          <Icon name="Edit" size={16} className="text-white" />
          <span>{pending ? "Exiting draft mode..." : "Draft mode is active"}</span>
        </div>
        <button
          type="submit"
          disabled={pending}
          aria-label="Exit draft mode"
          tabIndex={0}
          className="rounded-md border border-white/40 bg-white/10 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Exit Draft Mode
        </button>
      </div>
    </div>
  );
}

export default function DraftModeNotice({ isDraftMode }: DraftModeToastProps) {
  if (!isDraftMode) return null;

  return (
    <form action={disableDraftMode}>
      <DraftModeFormContent />
    </form>
  );
}
